import { Stack } from '@mui/material';
import { FC } from 'react';
import { ThemedSkeleton } from '@focuslee/shared-mini-app';
export const TodayQuestProgressSkeleton: FC = () => {
  return (
    <Stack 
        direction="column"
        style={{ paddingLeft: '10px', paddingRight: '10px', paddingBottom: '10px' }} 
        borderBottom='1px solid var(--tg-theme-section-bg-color)'
    >
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={0.5}>
            <ThemedSkeleton 
                variant="text" 
                width={120} 
                height={30} 
                sx={{ fontSize: '1rem' }} 
            />
            <ThemedSkeleton 
                variant="text" 
                width={20} 
                height={30} 
                sx={{ fontSize: '1rem' }} 
            />
        </Stack>
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={0.5}>
            <ThemedSkeleton 
                variant="text" 
                width={120} 
                height={20} 
                sx={{ fontSize: '1rem' }} 
            />
            <Stack direction="row" alignItems="center" gap={0.5}>
                {[0,1,2,3].map((i) => (
                    <ThemedSkeleton key={i} variant="rectangular" width={24} height={24} />
                ))}
            </Stack>
        </Stack>
    </Stack>
  );
};

